import { CreateProjectDocsPage } from "@/features/projects/create-project/create-project.docs.page";
import { createFileRoute } from "@tanstack/react-router";

// CR-181: step 3 of project creation — optional project documentation.
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs",
)({
  component: CreateProjectDocsPage,
});
